import React, { useState } from "react";
import { useSnackbar } from "notistack";
import delIcon from "../../../../assets/icons/new_icon/delete-2.svg";
import editIcon from "../../../../assets/icons/new_icon/edit-2.svg";
import downloadIcon from "../../../../assets/icons/new_icon/download.svg";
import downloadIconBlue from "../../../../assets/icons/new_icon/document-upload-white.svg";
interface Props {
  data: any;
  shipmentId: string;
  fetchDocs: any;
  setShowAddShipmentDocModal?: any;
}
function ItemsListing({
  data,
  shipmentId,
  fetchDocs,
  setShowAddShipmentDocModal,
}: Props) {
  const { enqueueSnackbar } = useSnackbar();
  const [selectedDocument, setSelectedDocument] = useState<any>();
  const [loading, setLoading] = useState(false);
  const [showEditShipmentDocModal, setShowEditShipmentDocModal] =
    useState(false);
  //   const handleShipmentDocAccordionToggle = () => {
  //     setShipmentDocExpanded(!shipmentDocExpanded);
  //   };
  return (
    <div className="ubbe-card accordion-border">
      {loading && (
        <div className="loader-container">
          <div className="spinner"></div>
        </div>
      )}

      <div
        className="accordion accordion-flush"
        style={{ backgroundColor: "transparent" }}
        id="shipment_document_accordion"
      >
        <div
          className="accordion-item border"
          style={{ backgroundColor: "transparent" }}
        >
          <h2 className="accordion-header" id="main_document_head">
            <div className="row align-items-center position-relative ">
              <div
                className="col-auto position-absolute z-3"
                style={{
                  right: "45px",
                  zIndex: "9999",
                  display: "flex",
                  justifyContent: "center",
                }}
              ></div>
              <div className="col">
                <button
                  className={`accordion-button  col-12 
               "active"
                  }`}
                  style={{ backgroundColor: "#251163" }}
                  type="button"
                  //   onClick={handleShipmentDocAccordionToggle}
                >
                  <h5
                    style={{ color: "white" }}
                    className="accordion-header boldsteppertext"
                    id="shipment_document_head"
                  >
                    Items{" "}
                  </h5>
                </button>
              </div>
            </div>
          </h2>

          <div
            id="main_document_body"
            className={`accordion-collapse collapse ${"show"}`}
            aria-labelledby="main_document_head"
            data-bs-parent="#main_leg_accordion"
          >
            <div className="accordion-body p-0 mt-2">
              <table
                className="table table-striped mb-0"
                id="shipment_document_table"
              >
                <thead className="ubbe-table-header">
                  <tr>
                    <th
                      className={`text-start align-middle ubbe-table-heading-text`}
                      scope="col"
                      style={{ width: "10%" }}
                    >
                      ID
                    </th>
                    <th
                      className={`text-start align-middle ubbe-table-heading-text`}
                      scope="col"
                      style={{ width: "10%" }}
                    >
                      Quantity
                    </th>
                    <th
                      className={`text-start align-middle ubbe-table-heading-text`}
                      scope="col"
                      style={{ width: "20%" }}
                    >
                      Accepted Date
                    </th>
                    <th
                      className={`text-start align-middle ubbe-table-heading-text`}
                      scope="col"
                      style={{ width: "10%" }}
                    >
                      Camp Container
                    </th>
                    <th
                      className={`text-start align-middle ubbe-table-heading-text`}
                      scope="col"
                      style={{ width: "10%" }}
                    >
                      Yard Location
                    </th>
                    <th
                      className={`text-start align-middle ubbe-table-heading-text`}
                      scope="col"
                      style={{ width: "10%" }}
                    >
                      Prioritiy
                    </th>
                    <th
                      className={`text-start align-middle ubbe-table-heading-text`}
                      scope="col"
                      style={{ width: "10%" }}
                    >
                      Weight (lbs)
                    </th>
                    <th
                      className={`text-start align-middle ubbe-table-heading-text`}
                      scope="col"
                      style={{ width: "10%" }}
                    >
                      Loaded
                    </th>
                    <th
                      className={`text-start align-middle ubbe-table-heading-text`}
                      scope="col"
                      style={{ width: "10%" }}
                    >
                      DG
                    </th>
                    <th
                      scope="col"
                      style={{ width: "5%" }}
                      className="text-center"
                    ></th>
                  </tr>
                </thead>
                <tbody id="shipment_document_rows">
                  {data && data.length > 0 ? (
                    data.map((item: any) => (
                      <tr data-document={`${JSON.stringify(data)}`}>
                        <td className="text-center align-middle">
                          {item?.date}
                        </td>

                        <td className="align-middle">{item?.type_name}</td>
                        <td className="align-middle">{item?.file_name}</td>

                        <td className="text-center align-middle"></td>
                        <td className="text-center align-middle">
                          <a
                            className="btn-ubbe-no-style px-1"
                            href={`data:application/pdf;base64,${item["document"]}`}
                            download={`${item["file_name"]}`}
                            target="_blank"
                            rel="noreferrer"
                          >
                            <img
                              alt="delete-icon"
                              src={downloadIcon}
                              className="packageBoxIcon"
                              style={{
                                backgroundColor: "#31BC0E1A",
                                width: "32px",
                              }}
                            />
                          </a>
                          <button
                            className="btn-ubbe-no-style"
                            onClick={() => {
                              setShowEditShipmentDocModal(true);
                              setSelectedDocument(item);
                            }}
                          >
                            <img
                              alt="delete-icon"
                              src={editIcon}
                              className="packageBoxIcon"
                              style={{
                                backgroundColor: "rgba(26, 97, 204, 0.10)",
                              }}
                            />
                          </button>
                          <button
                            style={{ color: "white" }}
                            className={`underline-blue`} // Adjust classes as needed
                            type="button"
                            onClick={() => {
                              setShowAddShipmentDocModal(true);
                            }} // Add your button click handler function
                          >
                            <img src={downloadIconBlue} className="mx-1" />
                            Upload
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan={9}
                        className="text-center global-text align-middle"
                        style={{ color: " #979797                      " }}
                      >
                        Items not found! Please try again.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ItemsListing;
